import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 19a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-0"}],["path",{"d":"M15 19a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-1"}],["path",{"d":"M17 17h-11v-14h-2","key":"svg-2"}],["path",{"d":"M6 5l14 1l-1 7h-13","key":"svg-3"}]]

const IconShoppingCart = createReactComponent('outline', 'shopping-cart', 'ShoppingCart', __iconNode);

export default IconShoppingCart;